<template>
  <div class="examhardlayout">
    <el-container>
      <el-main>
        <div class="content_wrapper">
          <el-table
            :data="tableData"
            header-row-class-name="header-row-class-name"
            border
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%">
            <el-table-column
              sortable
              prop="id"
              label="ID号">
            </el-table-column>

            <el-table-column
              sortable
              label="排序号"
              prop="ordinal">
            </el-table-column>
            <el-table-column
              label="难度名"
              prop="name">
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'
export default {
  name: 'examhardManage',
  data () {
    return {
      id: 0,
      stageId: 0,
      subjectId: 0,
      examhardDialogVisible: false,
      tableData: [],
      stages: [],
      subjects: []
    }
  },
  async mounted () {
    await this.fetchData()
  },
  methods: {

    async fetchData () {
      try {
        let data = await commonService.fetchCommonExamhard()
        if (data) {
          this.tableData = data
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    }
  }
}
</script>
<style scoped>
  .examhardlayout .clear{
    clear:both;
  }

  .examhardlayout .div2 .active{
    background-color: #00aaff;
    color:#fff;
  }
  .examhardlayout .div2 .el-radio-button{
    margin:10px;
    border-left:1px solid #dcdfe6 !important;
    boder-radius:4px !important;
  }
  .examhardlayout .div2{
    height:200px;
    padding:10px 0;
    margin-top:-10px;
    margin-bottom: 5px;
    background-color: #ffffff;
    color: #333;
  }
  .examhardlayout .div2 span{
    height:50px;
    line-height:50px;
    margin:0 40px;
    float: left;
  }
  .examhardlayout .div2 .btn{
    width:1500px;
    float: left;
  }

</style>
<style type="text/css">
  .examhardlayout .div2 .el-radio-button{
    margin:10px 10px;
    border: 1px solid #dcdfe6 !important;
    boder-radius:4px !important;
  }
  .examhardlayout .div2 .el-radio-button__inner{
    border:none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/layout/examhard-manage/index.vue